import { render } from "./WizardTab.vue?vue&type=template&id=1897a2d2"
import script from "./WizardTab.vue?vue&type=script&lang=js"
export * from "./WizardTab.vue?vue&type=script&lang=js"
script.render = render

export default script